<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import deleteZoneModal from './deleteZoneGMapModalContent.vue'

export default {
  name: 'deleteZoneButtonAndModal',
  components: {
    deleteZoneModal
  },
  props: ['idzone', 'routesubmit'],
  data() {
    return {
      showModalDelete: false
    }
  },
  methods: {
    afficheModalDelete() {
      this.showModalDelete = true;
    },
    closeModalDelete() {
      this.showModalDelete = false;
    }
  }
}
</script>

<template>
  <div>
    <button id="show-modal-delete" class="buttonOriginal" @click="afficheModalDelete"><span class="glyphicon glyphicon-trash" :title="trans.get('common.delete')"></span></button>

      <!-- use the modal component, pass in the prop -->
      <deleteZoneModal v-if="showModalDelete" @close="closeModalDelete" :routesubmit="this.routesubmit"  :idzone="this.idzone"></deleteZoneModal>
  </div>
</template>